module.exports = __webpack_public_path__ + "media/images/logo-paypal-214c7bba6fa5230e0c0023bd6db01f4e.svg";